<mat-toolbar color="primary" class="flex flex-row justify-between">

  <div class="text-base">
    <span class="text-xs" *ngIf=" !sessionSysAdmin &&  !sessionOpAdmin &&  !sessionOpUser &&  !sessionGroup &&  !sessionOpr">1.0.0</span>
    <span class="text-xs" *ngIf="!!sessionSysAdmin &&                                        !!sessionGroup &&  !sessionOpr">{{sessionGroup.group_code}} : {{sessionGroup.group_name}}</span>
    <span class="text-xs" *ngIf="!!sessionSysAdmin &&                                        !!sessionGroup && !!sessionOpr">{{sessionGroup.group_code}} : {{sessionGroup.group_name}} : {{sessionOpr.op_id}}</span>
    <span class="text-xs" *ngIf=" !sessionSysAdmin && !!sessionOpAdmin &&  !sessionOpUser && !!sessionGroup && !!sessionOpr">OP-ID : {{sessionOpr.op_id}}</span>
    <span class="text-xs" *ngIf=" !sessionSysAdmin &&  !sessionOpAdmin && !!sessionOpUser && !!sessionGroup && !!sessionOpr">OP-ID : {{sessionOpr.op_id}}</span>
  </div>

  <div class="text-xs space-x-2">
    <span *ngIf="!!sessionSysAdmin &&  !sessionOpAdmin &&  !sessionOpUser">{{'HTML-footer.システム管理者：' | translate}}{{sessionSysAdmin.name}}</span>
    <span *ngIf=" !sessionSysAdmin && !!sessionOpAdmin &&  !sessionOpUser">{{'HTML-footer.OP管理者：' | translate}}{{sessionOpAdmin.name}}</span>
    <span *ngIf=" !sessionSysAdmin &&  !sessionOpAdmin && !!sessionOpUser">{{'HTML-footer.CAユーザー：' | translate}}{{sessionOpUser.name}}</span>
    <span *ngIf=" !sessionSysAdmin &&  !sessionOpAdmin &&  !sessionOpUser">COPYRIGHT DENTSU SOKEN INC.</span>
    <span>{{time | date:'HH:mm':'+09:00'}} JPN</span>
  </div>

</mat-toolbar>
